module.exports = __webpack_public_path__ + "assets/img/logo.d8b1ac18.png";